import React from "react";

import {
  type ITimeGranularityV2,
  TimeGranularityV2,
} from "@north-beam/nb-common";

import { Select } from "..";

interface Props {
  label?: string | React.ReactElement;
  className?: string;
  isLoading?: boolean;
  timeGranularity: ITimeGranularityV2;
  hideHourlyOption?: boolean;
  hiddenGranularities?: ITimeGranularityV2[];
  onChange: (obj: any) => void;
}

export const TimeGranularityV2Select = ({
  label,
  className,
  isLoading = false,
  timeGranularity,
  hiddenGranularities,
  hideHourlyOption = false,
  onChange,
  ...props
}: Props) => {
  const options = (
    hideHourlyOption
      ? TimeGranularityV2.reactSelectOptions.filter((e) => e.value !== "hourly")
      : TimeGranularityV2.reactSelectOptions
  ).filter((i) => !hiddenGranularities?.includes(i.value));

  return (
    <Select
      buttonClassName={className}
      disabled={isLoading}
      value={TimeGranularityV2.toReactSelect(timeGranularity).value}
      options={options}
      onChange={onChange}
      {...props}
    />
  );
};
